(function() {
  define('bazemont/event/item',['angular'], function() {
    'use strict';
    return angular.module('bazemontEventItem', []).component('bazemontEventItem', {
      templateUrl: '/assets/javascripts/bazemont/event/item.html',
      bindings: {
        event: '=',
        forbidPastEvents: '<',
        categories: '<',
        isAdmin: '<'
      },
      controller: [
        function() {
          var hasId, vm;
          vm = this;
          vm.isAllowed = function() {
            return vm.isAdmin || hasId(vm.categories, vm.event.category);
          };
          hasId = function(elements, element) {
            return elements && element && elements.some(function(current) {
              return current.id === element.id;
            });
          };
        }
      ]
    });
  });

}).call(this);

//# sourceMappingURL=item.js.map
;
